import { Component } from '@angular/core';
import { ProductPageLinkResolverService } from '@ddt-web/data-service';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
	selector: 'ac-link-cell-renderer',
	templateUrl: './link-cell-renderer.component.html',
	styleUrls: ['./link-cell-renderer.component.scss']
})
export class LinkCellRendererComponent implements ICellRendererAngularComp {
	public params: any;
	public productUrl: string;
	public isFundIdea: boolean = false;
	public fundIdeaTrackingString: string;

	constructor(private linkResolverService: ProductPageLinkResolverService) { }

	public refresh(params: any): boolean {
		return true;
	}

	public agInit(params: any): void {
		this.params = params;
		if (params && params.value && params.value.attribute['url']) {
			const productLink = params.value.attribute['productPageLink'];
			this.productUrl = this.linkResolverService.getUrlByAssetType(productLink, params.value.attribute['url']);
			if (this.productUrl) {
				this.isFundIdea = !!params.data?.lightbulb?.attribute?.isChild;
				if (this.isFundIdea) {
					this.fundIdeaTrackingString = `portfolio-analyser:portfolioanalysercomponent:fund-idea:${params.data.ticker.rawValue.toLowerCase()}`;
				}
			}
		}
	}
}
